import 'reflect-metadata';
import * as Sentry from '@sentry/vue';

import '@ui/globals.css';
import twMergeDirective from 'tailwind-merge-vue-directive';
import { createApp } from 'vue';

import { HttpError } from '@stuut/common/src/api_client';
import { toast, ToastError } from '@ui/components/sonner';

import App from './App.vue';
import plugins from './plugins';
import router from './router';

function stuutErrorHandler(err, instance, info) {
  if (err instanceof ToastError) {
    toast.error(err.message);
    return true;
  } else if (err instanceof HttpError && err.clientMessage) {
    toast.error(err.clientMessage);
    return true;
  }
  return false;
}

function isBotErrorSpam(event) {
  const msg = String(event.message || event.exception?.values?.[0]?.value || '');

  // Ignore this signature
  if (/Object Not Found Matching Id:\d+, MethodName:update, ParamCount:\d+/.test(msg)) {
    return true;
  }

  if (/\[PostHog\.js\]\s+This capture call is ignored due to client rate limiting\./i.test(msg)) {
    return true;
  }

  return false;
}

const app = createApp(App);
if (process.env.STUUT_SENTRY_DSN) {
  Sentry.init({
    app,
    beforeSend(event, hint) {
      const isHandled = stuutErrorHandler(hint.originalException, null, null);
      if (isHandled || isBotErrorSpam(event)) {
        return null;
      }
      return event;
    },
    dsn: process.env.STUUT_SENTRY_DSN,
    environment: process.env.NODE_ENV || 'development',
    integrations: [Sentry.captureConsoleIntegration({ levels: ['error'] })],
  });
}

app.use(plugins);
app.use(router);
app.use(twMergeDirective);

app.directive('visible', (el, binding) => {
  el.style.visibility = binding.value ? 'visible' : 'hidden';
});

app.mount('#app');
